/** A table cell with a campaign's Eastern date over its time. */
import { formatCampaignDate, formatCampaignTime } from '@bonsai/shared';

export function TicketSalesCampaignWhenCell({ instant }: { instant: string }) {
  return (
    <td style={{ whiteSpace: 'nowrap' }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--nb-ink-2)' }}>
        {formatCampaignDate(instant)}
      </div>
      <div className="nb-tabular" style={{ fontSize: 11.5, color: 'var(--nb-subtle)' }}>
        {formatCampaignTime(instant)}
      </div>
    </td>
  );
}
